﻿module.exports = {
    "id": "no",
    "label": "Norsk",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":               "Ugyldig Lenke",
        "INVALID_LINK_TEXT":                "Vennligst bruk lenken i e-posten hvis du vil stoppe abonnementet på våre e-postlister.",
        "UNSUBSCRIBE_ARE_YOU_SURE":         "Er du sikker på at du vil stoppe abonnementet på denne e-postadresseen fra våre e-postlister?",
        "UNSUBSCRIBE_CLICK_CONFIRM":        "Klikk på \"Stopp Abonnement\"-knappen nedenfor for å bekrefte.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":       "Abonnementet ditt på våre e-postlister har blitt <b>stoppet</b>.",
        "UNSUBSCRIBED_IN_ERROR":            "Hvis du har stoppet abonnementet ved en feil, kan du klikke på <a href='/resubscribe' class='resubscribe'>Start abonnement på nytt</a>-lenken.",
        "CANCELLED_STILL_SUBSCRIBED":       "<b>Annullert.</b> Du <b>abonnerer</b> fortsatt på våre e-postlister.",
        "THANK_YOU_FOR_CONTINUING":         "Takk for at du fortsetter å delta i våre undersøkelser.",
        "EMAIL_ALREADY_UNSUBSCRIBED":       "Denne e-posteadressen har allerede <b>stanset abonnementet</b> fra våre e-postlister.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":      "Klikk på \"Start Abonnement På Nytt\"-knappen nedenfor for å komme tilbake på våre e-postlister.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":       "Du har nå <b>startet abonnementet</b> på våre e-postlister på nytt.",
        "YOU_ARE_ALREADY_SUBSCRIBED":       "Du <b>abonnerer</b>allerede på våre e-postlister.",
        "THANK_YOU_FOR_PARTICIPATING":      "Takk for at du deltar i våre undersøkelser.",
        "CHECKING":                         "Kontrollerer...",
        "UNSUBSCRIBE":                      "Stopp Abonnement",
        "RESUBSCRIBE":                      "Start Abonnement På Nytt",
        "EMAIL":                            "E-post",
        "CANCEL":                           "Annuller"
    }
};

